import { icons } from "assets";
import Button from "Components/shared/button";
import Modal from "Components/shared/modal";
import Text from "Components/shared/text";
import React from "react";

const TransactionSummary = ({
  onComplete,
  data,
  hidden,
  isLoading,
  ...props
}) => {
  const entries = Object.entries(data);

  return (
    <div {...props}>
      <div style={{ width: "70%", margin: "auto", textAlign: "center" }}>
        {hidden ? null : (
          <Text variant="md2" style={{ fontWeight: 800, paddingBottom: "8px" }}>
            Transaction Summary
          </Text>
        )}
      </div>
      <div
        className="row-start"
        style={{ marginTop: "52px", gap: "1rem", flexDirection: "column" }}
      >
        {entries.map(([key, value]) => (
          <Row key={key} label={key} value={value} />
        ))}
      </div>
      <div
        className="row-start"
        style={{ marginTop: "51px", marginBottom: "54px" }}
      >
        <Button
          loading={isLoading}
          onClick={() => onComplete(props.amount, props.cardNumber)}
        >
          Complete Transaction
        </Button>
      </div>
    </div>
  );
};

const Row = ({ label, value }) => {
  return (
    <div
      className="row-start w-full"
      style={{
        justifyContent: "space-between",
        borderBottom: "1px solid #E2E8F0",
        paddingBottom: "1rem",
      }}
    >
      <Text variant="sm" color="secondary">
        {label}
      </Text>
      <Text variant="sm" style={{ fontWeight: 700 }}>
        {value}
      </Text>
    </div>
  );
};

export default TransactionSummary;
